import React from 'react'
import { observer } from 'mobx-react-lite'

import {
  CurrencyInput,
  ListItemAction,
  useAccountStore,
  useGlobalCopyStore,
  useEvent,
  ANALYTICS_EVENTS,
} from '../../../common'
import { DebtChartData } from '../../../core/utils/DebtUtils'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

interface OriginalBalanceActionProps {
  debt: DebtChartData
}

export const OriginalBalanceAction = observer(({ debt }: OriginalBalanceActionProps) => {
  const { debts: copy } = useGlobalCopyStore()
  const { updateAccount } = useAccountStore()
  const { onEvent } = useEvent()

  const [balance, setBalance] = React.useState<number>(debt.original_balance ?? 0)
  const isInvalid = balance < 0 || balance > 99999999.99

  const handleSave = async () => {
    await updateAccount({ ...debt.account, original_balance: balance })
    debt.original_balance = balance
    onEvent(ANALYTICS_EVENTS.DEBTS_SAVE_BALANCE_ACTION, { account_guid: debt.guid })
  }

  const handleCancel = () => {
    setTimeout(() => {
      setBalance(debt.original_balance ?? 0)
    }, 250)
  }

  return (
    <ListItemAction
      isSaveDisabled={isInvalid}
      label={copy.details_original_balance}
      onCancel={handleCancel}
      onSave={handleSave}
      primaryText={copy.details_original_balance}
      secondaryText={formatCurrency(debt.original_balance, '0,0')}
      zeroStateText={!debt.original_balance ? copy.add_original_balance : undefined}
    >
      <CurrencyInput
        amount={balance}
        autoFocus={true}
        error={isInvalid}
        fullWidth={true}
        minAmount={0}
        setAmount={(v) => setBalance(!isNaN(Number(v)) ? Number(v) : balance)}
        sx={{ '.MuiTypography-body1': { p: 0 } }}
      />
    </ListItemAction>
  )
})
